import { CSSProperties } from 'react'
import './BoxContainer.css'

type BoxContainerProps = {
  visible: boolean,
  position: CSSProperties,
  titleBox?: string,
  titleDescription: string[],
  description: string[],
  asInfoBlock?: boolean
}

export default function BoxContainer(props: BoxContainerProps) {
  const firstTitleDescription = props.titleDescription.slice(0, props.titleDescription.length - 1);
  const firstDescription = props.description.slice(0, props.description.length - 1);

  const RowData = (left: string[], right: string[]) => {
    return (
      <div style={{ display: "flex", flex: 1, flexDirection: "column", justifyContent: "space-between", gap: "16px" }}>
        {left.map(function (leftString, index) {
          return (
            Row(leftString, right[index])
          )
        })}
      </div>
    )
  }

  const Row = (left: string, right: string) => {
    return (
      <div style={{ display: "flex", flexDirection: "row" }}>
        <div className='left-text' style={{ display: "flex", flex: 1, fontSize: "24px" }}>
          {left}
        </div>
        <div className='right-text' style={{ fontSize: "28px", fontWeight: 600 }}>
          {right}
        </div>
      </div>
    )
  }

  return (
    props.visible === true ?
      <div className='box-container' style={props.position}>
        <div style={{ fontSize: "48px", fontWeight: 600 }}>{props.titleBox}</div>
        {props.asInfoBlock == false ? RowData(props.titleDescription, props.description) : <></>}
        {props.asInfoBlock == true ? <>
          <div style={{ display: "flex", flex: 1, flexDirection: "column", justifyContent: "space-between", gap: "16px" }}>
            {/* sezione model name */}
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div className='left-text' style={{ display: "flex", flex: 1, fontSize: "24px" }}>
                {props.titleDescription[0]}
              </div>
              <div className='right-text' style={{ fontSize: "28px", fontWeight: 600 }}>
                {props.description[0]}
              </div>
            </div>
            {/* sezione materiale */}
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div className='left-text' style={{ display: "flex", flex: 1, fontSize: "24px" }}>
                {props.titleDescription[1]}
              </div>
              <div className='right-text' style={{ fontSize: "28px", fontWeight: 600 }}>
                {props.description[1]}
              </div>
            </div>
            {/* sezione dimension only */}
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div className='left-text' style={{ display: "flex", flex: 1, fontSize: "24px" }}>
                {props.titleDescription[2]}
              </div>
            </div>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "end" }}>
              <div className='right-text' style={{ fontSize: "28px", fontWeight: 600 }}>
                {props.description[2]}
              </div>
            </div>
            <div style={{ display: "flex", flexDirection: "row", justifyContent:"end" }}>
              <div className='right-text' style={{ fontSize: "28px", fontWeight: 600 }}>
                {props.description[3]}
              </div>
            </div>
          </div>
        </> : <></>}
      </div> : <></>
  )
}